import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type FutureRegion = z.infer<typeof FutureRegionRuntype>;
export const FutureRegionRuntype = z.enum(['Europe', 'NorthAmerica', 'Asia']);
export const FUTURE_REGION_OPTIONS = FutureRegionRuntype.options;

export interface FutureActivatedRegions extends z.infer<typeof FutureActivatedRegionsRuntype> {}
export const FutureActivatedRegionsRuntype = z.array(FutureRegionRuntype).default(['Europe', 'NorthAmerica', 'Asia']);

export interface FutureCredentialsDTO extends z.infer<typeof FutureCredentialsDTORuntype> {}
export const FutureCredentialsDTORuntype = z.object({
    api_key: z.string(),
    activated_regions: FutureActivatedRegionsRuntype.optional(),
});

export interface FutureCredentialsInputDTO extends z.infer<typeof FutureCredentialsInputDTORuntype> {}
export const FutureCredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    activated_regions: FutureActivatedRegionsRuntype.optional(),
});

export interface FutureResponseBodyDTO extends z.infer<typeof FutureResponseBodyDTORuntype> {}
export const FutureResponseBodyDTORuntype = z.object({
    data: FutureCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
